import CUSTOM_PALETTE from '../../../features/theme/dark'

const PALETTE = {
    MuiTypography: {
        ...CUSTOM_PALETTE?.MuiTypography,
        global: 'rgba(231, 231, 231, 1)',
        secondary: '#6E7781'
    },
    MuiButton: {
        ...CUSTOM_PALETTE?.MuiButton,
        company: {
            background: 'rgba(237, 0, 0, 1)',
            color: 'rgba(255, 255, 255, 1)',
            border: 'rgba(237, 0, 0, 1)',
            hover: 'rgba(186, 0, 0, 1)',
            hoverColor: 'rgba(255, 255, 255, 1)',
            hoverBorder: 'rgba(186, 0, 0, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.company,
        },
        primary: {
            background: 'rgba(121, 151, 249, 1)',
            color: 'rgba(21, 23, 26, 1)',
            border: 'rgba(121, 151, 249, 1)',
            hover: 'rgba(157, 179, 251, 1)',
            hoverColor: 'rgba(21, 23, 26, 1)',
            hoverBorder: 'rgba(157, 179, 251, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.primary,
        },
        secondary: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(121, 151, 249, 1)',
            border: 'rgba(121, 151, 249, 1)',
            hover: 'rgba(255, 255, 255, 0.05)',
            hoverColor: 'rgba(121, 151, 249, 1)',
            hoverBorder: 'rgba(121, 151, 249, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.secondary,
        },
        tertiary: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(121, 151, 249, 1)',
            border: 'rgba(0, 0, 0, 0)',
            hover: 'rgba(255, 255, 255, 0.05)',
            hoverColor: 'rgba(121, 151, 249, 1)',
            hoverBorder: 'rgba(0, 0, 0, 0)',
            ...CUSTOM_PALETTE?.MuiButton?.tertiary,
        },
        header: {
            background: 'rgba(0, 0, 0, 0)',
            hover: 'rgba(0, 0, 0, 0.05)',
            color: 'rgba(255, 255, 255, 0.6)',
            colorHover: 'rgba(255, 255, 255, 1)',
            border: 'rgba(255, 255, 255, 1)',
            selectedColor: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.header
        },
        universe: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(255, 255, 255, 1)',
            border: 'rgba(0, 0, 0, 0)',
            hover: 'rgba(255, 255, 255, 0.05)',
            hoverColor: 'rgba(255, 255, 255, 1)',
            hoverBorder: 'rgba(0, 0, 0, 0)',
            ...CUSTOM_PALETTE?.MuiButton?.tertiary,
        }
    },
    Tile: {
        ...CUSTOM_PALETTE?.Tile,
        primary :{
            background: 'rgba(34, 36, 41, 1)',
            border: 'rgba(255, 255, 255, 0.15)',
            hover: 'rgba(65, 70, 78, 1)',
            checked: 'rgba(121, 151, 249, 1)',
            ...CUSTOM_PALETTE?.Tile?.primary,
            color: {
                main: 'rgba(255, 255, 255, 1)',
                hover: 'rgba(255, 255, 255, 1)',
                label: 'rgba(255, 255, 255, 1)',
                hoverLabel: 'rgba(255, 255, 255, 1)',
                sublabel: 'rgba(255, 255, 255, 1)',
                hoverSublabel: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tile?.primary?.color
            }
        }
    },
    toggleGroup: {
        ...CUSTOM_PALETTE?.toggleGroup,
        primary: {
            group: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.toggleGroup?.primary,
            selected: {
                background: 'rgba(255, 255, 255, 0.15)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.primary?.selected
            },
            hover: {
                background: 'rgba(255, 255, 255, 0.15)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.primary?.hover
            },
            unselected: {
                background: 'rgba(0, 0, 0, 0)',
                color: 'rgba(255, 255, 255, 0.6)',
                ...CUSTOM_PALETTE?.toggleGroup?.primary?.hover
            }
        },
        secondary: {
            group: 'rgba(47, 51, 57, 1)',
            ...CUSTOM_PALETTE?.toggleGroup?.secondary,
            selected: {
                background: 'rgba(255, 255, 255, 0.15)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.secondary?.selected
            },
            hover: {
                background: 'rgba(255, 255, 255, 0.15)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.secondary?.hover
            },
            unselected: {
                background: 'rgba(0, 0, 0, 0)',
                color: 'rgba(255, 255, 255, 0.6)',
                ...CUSTOM_PALETTE?.toggleGroup?.secondary?.hover
            }
        }
    },
    MuiCheckbox: {
        ...CUSTOM_PALETTE?.MuiCheckbox,
        primary: {
            unchecked: 'rgba(255, 255, 255, 0.3)',
            checked: 'rgba(121, 151, 249, 1)',
            indeterminate: 'rgba(121, 151, 249, 1)',
            ...CUSTOM_PALETTE?.MuiCheckbox?.primary
        }
    },
    MuiFormLabel: {
        primary: 'rgba(255, 255, 255, 0.6)',
        success: 'rgba(64, 120, 70, 1)',
        ...CUSTOM_PALETTE?.MuiFormLabel
    },
    MuiFormControlLabel: {
        primary: 'rgba(255, 255, 255, 1)',
        ...CUSTOM_PALETTE?.MuiFormControlLabel
    },
    MuiFormHelperText: {
        primary: 'rgba(255, 255, 255, 0.6)',
        ...CUSTOM_PALETTE?.MuiFormHelperText
    },
    MuiRadio: {
        ...CUSTOM_PALETTE?.MuiRadio,
        primary: {
            unchecked: 'rgba(255, 255, 255, 0.3)',
            checked: 'rgba(121, 151, 249, 1)',
            ...CUSTOM_PALETTE?.MuiRadio?.primary
        }
    },
    MuiSwitch: {
        ...CUSTOM_PALETTE?.MuiSwitch,
        primary: {
            ...CUSTOM_PALETTE?.MuiSwitch?.primary,
            thumb: {
                checked: 'rgba(21, 23, 26, 1)',
                unchecked: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.MuiSwitch?.primary?.thumb
            },
            background: {
                checked: 'rgba(121, 151, 249, 1)',
                unchecked: 'rgba(147, 157, 173, 1)',
                ...CUSTOM_PALETTE?.MuiSwitch?.primary?.background
            }
        }
    },
    MuiMenu: {
        ...CUSTOM_PALETTE?.MuiMenu,
        primary: {
            background: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiMenu?.primary
        }
    },
    MuiMenuItem: {
        ...CUSTOM_PALETTE?.MuiMenuItem,
        primary: {
            iconColor: 'rgba(255, 255, 255, 1)',
            iconHoverColor: 'rgba(121, 151, 249, 1)',
            background: 'rgba(34, 36, 41, 1)',
            color: 'rgba(255, 255, 255, 1)',
            hoverColor: 'rgba(255, 255, 255, 1)',
            hoverBackground: 'rgba(0, 0, 0, 0.05)',
            selectedColor: 'rgba(121, 151, 249, 1)',
            selectedBackground: 'rgba(0, 0, 0, 0.3)',
            ...CUSTOM_PALETTE?.MuiMenuItem?.primary
        }
    },
    MuiListSubheader: {
        ...CUSTOM_PALETTE?.MuiListSubheader,
        primary: {
            background: 'rgba(34, 36, 41, 0.15)',
            color: 'rgba(255, 255, 255, 0.6)',
            ...CUSTOM_PALETTE?.MuiListSubheader?.primary
        }
    },
    MuiTabs: {
        ...CUSTOM_PALETTE?.MuiTabs,
        primary: {
            background: 'rgba(0, 0, 0, 0)',
            border: 'rgba(255, 255, 255, 0.15)',
            selectedBorder: 'rgba(121, 151, 249, 1)',
            ...CUSTOM_PALETTE?.MuiTabs?.primary
        }
    },
    MuiTab: {
        ...CUSTOM_PALETTE?.MuiTab,
        primary: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiTab?.primary
        }
    },
    MuiLink: {
        ...CUSTOM_PALETTE?.MuiLink,
        primary: {
            color: 'rgba(121, 151, 249, 1)',
            hover: 'rgba(157, 179, 251, 1)',
            background: 'rgba(0, 0, 0, 0)',
            backgroundHover: 'rgba(0, 0, 0, 0)',
            ...CUSTOM_PALETTE?.MuiLink?.primary
        }
    },
    MuiDialog: {
        ...CUSTOM_PALETTE?.MuiDialog,
        primary: {
            wrapper: 'transparent',
            background: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiDialog?.primary
        }
    },
    MuiDialogTitle: {
        ...CUSTOM_PALETTE?.MuiDialogTitle,
        primary: {
            background: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiDialogTitle?.primary
        }
    },
    MuiDialogContent: {
        ...CUSTOM_PALETTE?.MuiDialogContent,
        primary: {
            background: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiDialogContent?.primary
        }
    },
    MuiDialogActions: {
        ...CUSTOM_PALETTE?.MuiDialogActions,
        primary: {
            background: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiDialogActions?.primary
        }
    },
    MuiLinearProgress: {
        ...CUSTOM_PALETTE?.MuiLinearProgress,
        background: 'rgba(255, 255, 255, 0.15)',
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.primary
        },
        secondary: {
            background: 'rgba(255, 255, 255, 0.15)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.secondary
        },
        success: {
            background: 'rgba(45, 164, 78, 1)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.success
        },
        error: {
            background: 'rgba(237, 0, 0, 1)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.error
        }
    },
    MuiAlert: {
        ...CUSTOM_PALETTE?.MuiAlert,
        info: {
            background: 'rgba(11, 22, 55, 1)',
            border: 'rgba(31, 73, 210, 1)',
            color: 'rgba(157, 179, 251, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.info
        },
        success: {
            background: 'rgba(18, 27, 6, 1)',
            border: 'rgba(54, 99, 0, 1)',
            color: 'rgba(130, 201, 45, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.success
        },
        warning: {
            background: 'rgba(27, 24, 8, 1)',
            border: 'rgba(100, 88, 2, 1)',
            color: 'rgba(207, 182, 3, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.warning
        },
        error: {
            background: 'rgba(59, 0, 0, 1)',
            border: 'rgba(180, 0, 0, 1)',
            color: 'rgba(248, 157, 157, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.error
        }
    },
    MuiAccordion: {
        iconWrapper: 'rgba(255, 255, 255, 1)',
        background: 'rgba(21, 23, 26, 1)',
        border: 'rgba(255, 255, 255, 0.5)',
        ...CUSTOM_PALETTE?.MuiAccordion
    },
    MuiAccordionSummary: {
        background: 'rgba(21, 23, 26, 1)',
        color: 'rgba(255, 255, 255, 1)',
        ...CUSTOM_PALETTE?.MuiAccordionSummary
    },
    MuiPickersLayout: {
        background: 'rgba(21, 23, 26, 1)'
    },
    Textinput: {
        primary: {
            fieldSet: 'rgba(255, 255, 255, 0.15)',
            fieldSetHover: 'rgba(121, 151, 249, 1)',
            fieldSetSuccess: 'rgba(97, 143, 100, 1)',
            color: 'rgba(255, 255, 255, 1)',
            background: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.Textinput?.primary
        },
        secondary: {
            fieldSet: 'rgba(255, 255, 255, 0.15)',
            fieldSetHover: 'rgba(121, 151, 249, 1)',
            fieldSetSuccess: 'rgba(97, 143, 100, 1)',
            color: 'rgba(255, 255, 255, 0.6)',
            background: 'rgba(65, 70, 78, 1)',
            ...CUSTOM_PALETTE?.Textinput?.secondary
        },
        ...CUSTOM_PALETTE?.Textinput?.variants
    },
    Tag: {
        ...CUSTOM_PALETTE?.Tag,
        red: {
            ...CUSTOM_PALETTE?.Tag?.red,
            main: {
                background: 'rgba(59, 0, 0, 1)',
                border: 'rgba(135, 0, 0, 1)',
                color: 'rgba(245, 115, 115, 1)',
                ...CUSTOM_PALETTE?.Tag?.red?.main
            },
            contrasted: {
                background: 'rgba(241, 60, 60, 1)',
                border: 'rgba(241, 60, 60, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.red?.contrasted
            }
        },
        green: {
            ...CUSTOM_PALETTE?.Tag?.green,
            main: {
                background: 'rgba(18, 27, 6, 1)',
                border: 'rgba(40, 72, 0, 1)',
                color: 'rgba(95, 175, 0, 1)',
                ...CUSTOM_PALETTE?.Tag?.green?.main
            },
            contrasted: {
                background: 'rgba(79, 146, 0, 1)',
                border: 'rgba(79, 146, 0, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.green?.contrasted
            }
        },
        blue: {
            ...CUSTOM_PALETTE?.Tag?.blue,
            main: {
                background: 'rgba(11, 22, 55, 1)',
                border: 'rgba(23, 53, 154, 1)',
                color: 'rgba(121, 151, 249, 1)',
                ...CUSTOM_PALETTE?.Tag?.blue?.main
            },
            contrasted: {
                background: 'rgba(82, 121, 247, 1)',
                border: 'rgba(82, 121, 247, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.blue?.contrasted
            }
        },
        yellow: {
            ...CUSTOM_PALETTE?.Tag?.yellow,
            main: {
                background: 'rgba(27, 24, 8, 1)',
                border: 'rgba(73, 64, 1, 1)',
                color: 'rgba(178, 155, 3, 1)',
                ...CUSTOM_PALETTE?.Tag?.yellow?.main
            },
            contrasted: {
                background: 'rgba(148, 130, 2, 1)',
                border: 'rgba(148, 130, 2, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.yellow?.contrasted
            }
        },
        grey: {
            ...CUSTOM_PALETTE?.Tag?.grey,
            main: {
                background: 'rgba(23, 24, 27, 1)',
                border: 'rgba(60, 64, 72, 1)',
                color: 'rgba(151, 156, 165, 1)',
                ...CUSTOM_PALETTE?.Tag?.grey?.main
            },
            contrasted: {
                background: 'rgba(124, 130, 142, 1)',
                border: 'rgba(124, 130, 142, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.grey?.contrasted
            }
        },
        orange: {
            ...CUSTOM_PALETTE?.Tag?.orange,
            main: {
                background: 'rgba(38, 20, 3, 1)',
                border: 'rgba(97, 53, 7, 1)',
                color: 'rgba(235, 127, 16, 1)',
                ...CUSTOM_PALETTE?.Tag?.orange?.main
            },
            contrasted: {
                background: 'rgba(197, 106, 14, 1)',
                border: 'rgba(197, 106, 14, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.orange?.contrasted
            }
        },
        pink: {
            ...CUSTOM_PALETTE?.Tag?.pink,
            main: {
                background: 'rgba(50, 8, 23, 1)',
                border: 'rgba(125, 20, 55, 1)',
                color: 'rgba(228, 122, 158, 1)',
                ...CUSTOM_PALETTE?.Tag?.pink?.main
            },
            contrasted: {
                background: 'rgba(220, 78, 126, 1)',
                border: 'rgba(220, 78, 126, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.pink?.contrasted
            }
        },
        purple: {
            ...CUSTOM_PALETTE?.Tag?.purple,
            main: {
                background: 'rgba(31, 16, 53, 1)',
                border: 'rgba(81, 41, 135, 1)',
                color: 'rgba(179, 134, 241, 1)',
                ...CUSTOM_PALETTE?.Tag?.purple?.main
            },
            contrasted: {
                background: 'rgba(157, 99, 236, 1)',
                border: 'rgba(157, 99, 236, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.purple?.contrasted
            }
        },
        teal: {
            ...CUSTOM_PALETTE?.Tag?.teal,
            main: {
                background: 'rgba(4, 28, 24, 1)',
                border: 'rgba(11, 72, 62, 1)',
                color: 'rgba(27, 175, 149, 1)',
                ...CUSTOM_PALETTE?.Tag?.teal?.main
            },
            contrasted: {
                background: 'rgba(22, 146, 124, 1)',
                border: 'rgba(22, 146, 124, 1)',
                color: 'rgba(21, 23, 26, 1)',
                ...CUSTOM_PALETTE?.Tag?.teal?.contrasted
            }
        }
    },
    Combobox: {
        expander: 'rgba(34, 36, 41, 1)',
        fieldSet: {
            color: 'rgba(255, 255, 255, 0.15)',
            hover: 'rgba(121, 151, 249, 1)'
        },
        textinput: {
            background: 'rgba(34, 36, 41, 1)'
        },
        popper: {
            background: 'rgba(34, 36, 41, 1)'
        }
    },
    SingleSelect: {
        primary:  {
            background: 'rgba(34, 36, 41, 1)',
            color: 'rgba(255, 255, 255, 0.6)',
            fieldSet: 'rgba(255, 255, 255, 0.15)',
            fieldSetHover: 'rgba(121, 151, 249, 1)',
            expander: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.SingleSelect
        },
        secondary:  {
            background: 'rgba(65, 70, 78, 1)',
            color: 'rgba(255, 255, 255, 1)',
            fieldSet: 'rgba(255, 255, 255, 0.15)',
            fieldSetHover: 'rgba(121, 151, 249, 1)',
            expander: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.SingleSelect
        }
    },
    Datatable: {
        background: 'rgba(21, 23, 26, 1)',
        ...CUSTOM_PALETTE?.Datatable,
        grid: {
            background: 'rgba(21, 23, 26, 1)',
            border: 'rgba(255, 255, 255, 0.15)',
            ...CUSTOM_PALETTE?.Datatable?.grid
        },
        header: {
            background: 'rgba(34, 36, 41, 1)',
            color: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.Datatable?.header
        },
        row: {
            error: 'rgba(255, 151, 137, 1)',
            color: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.Datatable?.row
        }
    },
    loader: {
        main: 'rgba(249, 250, 251, 1)',
        color: 'rgba(34, 43, 45, 1)',
        ...CUSTOM_PALETTE?.loader
    },
    body: {
        background: 'rgba(21, 23, 26, 1)',
        ...CUSTOM_PALETTE?.body
    },
    leftPanel: {
        background: 'rgba(34, 36, 41, 1)',
        hover: 'rgba(0, 0, 0, 0.05)',
        hoverColor: 'rgba(255, 255, 255, 1)',
        color: 'rgba(255, 255, 255, 0.6)',
        selected: 'rgba(0, 0, 0, 0.1)',
        selectedBorder: 'rgba(255, 255, 255, 1)',
        selectedColor: 'rgba(255, 255, 255, 1)',
        ...CUSTOM_PALETTE?.leftPanel
    },
    toolbar: {
        background: 'rgba(34, 36, 41, 1)',
        color: 'rgba(255, 255, 255, 1)',
        item: {
            color: 'rgba(255, 255, 255, 0.6)',
            hoverColor: 'rgba(255, 255, 255, 1)',
            background: 'rgba(34, 36, 41, 1)',
            hover: 'rgba(0, 0, 0, 0.05)'
        },
        ...CUSTOM_PALETTE?.toolbar
    },
    Magnet: {
        border: 'rgba(255, 255, 255, 1)'
    },
    background: {
        transparent: 'transparent',
        boxShadow: 'rgba(149, 157, 165, 0.2)',
        body: 'rgba(249, 250, 251, 1)',
        main: '#F7F9FA',
        layer: {
            main: {
                main: '#FFFFFF',
                hover: '#FAFAFA',
                active: '#EBEEEF',
                ...CUSTOM_PALETTE?.background?.layer?.main
            },
            alt: {
                main: '#F7F9FA',
                hover: '#F7F9FA',
                active: '#EBEEEF',
                ...CUSTOM_PALETTE?.background?.layer?.alt
            },
            ...CUSTOM_PALETTE?.background?.layer
        },
        success: '#BCF453',
        alert: '#FF9789',
        warning: 'rgba(214, 129, 0, 1)',
        info: '#80CDFF',
        ...CUSTOM_PALETTE?.background
    },
    text: {
        primary: 'rgba(255, 255, 255, 1)',
        secondary: '#6E7781',
        placeholder: '#909498',
        error: '#D10000',
        disabled: '#85888A',
        legend: 'rgba(97, 94, 131, 1)',
        contrasted: {
            primary: '#FFFFFF',
            disabled: '#85888A',
            ...CUSTOM_PALETTE?.text?.contrasted
        },
        ...CUSTOM_PALETTE?.text
    },
    accent: {
        success: '#40A900',
        alert: '#D10000',
        warning: 'rgba(214, 129, 0, 1)',
        info: '#285AFF',
        ...CUSTOM_PALETTE?.accent
    },
    field: {
        border: 'rgba(0, 0, 0, 0.1)',
        main: '#FFFFFF',
        hover: '#F7F9FA',
        disabled: '#EBEEEF',
        ...CUSTOM_PALETTE?.field
    },
    icon: {
        primary: 'rgba(255, 255, 255, 1)',
        secondary: '#6E7781',
        interactive: '#FFFFFF',
        disabled: '#85888A',
        contrasted: {
            primary: '#FFFFFF',
            disabled: '#85888A',
            ...CUSTOM_PALETTE?.icon?.contrasted
        },
        ...CUSTOM_PALETTE?.icon
    },
    border: {
        subtle: {
            main: 'rgba(0, 0, 0, 0.1)',
            alt: '#F7F9FA',
            ...CUSTOM_PALETTE?.border?.subtle
        },
        strong: {
            main: '#C3C5C5',
            alt: '#C3C5C5',
            ...CUSTOM_PALETTE?.border?.strong
        },
        interactive: '#ED0000',
        disabled: '#85888A',
        ...CUSTOM_PALETTE?.border
    },
    data: [
        '#ED9A9A',
        '#F48FB1',
        '#CE93D8',
        '#B39DDB',
        '#9FA8DA',
        '#90CAF9',
        '#80DEEA',
        '#80CBC4',
        '#C5E1A5',
        '#E6EE9C',
        '#FFF59D',
        '#FFCC80',
        '#FFAB91',
        '#ED0000',
        '#E91E63',
        '#9C27B0',
        '#673AB7',
        '#3F51B5',
        '#2196F3',
        '#009EB3',
        '#80CBC4',
        '#6FA136',
        '#87931A',
        '#D7C100',
        '#D68100',
        '#FF5722',
        '#A30000',
        '#AD1457',
        '#6A1B9A',
        '#4527A0',
        '#283593',
        '#1565C0',
        '#00838F',
        '#00695C',
        '#547A29',
        '#5C6411',
        '#9B8B00',
        '#AA6600',
        '#DD3400'
    ],
    overlay: 'rgba(51, 51, 51, 0.5)',
    grey: {
        default: '#6c757d',
        dark: '#343a40',
        '100': '#f8f9fa',
        '200': '#e9ecef',
        '300': '#dee2e6',
        '400': '#ced4da',
        '500': '#adb5bd',
        '600': '#6c757d',
        '700': '#495057',
        '800': '#343a40',
        '900': '#212529'
    },
    custom: {
        ...CUSTOM_PALETTE?.custom
    }
}

export default PALETTE